import type { PostChild } from '$lib/api/restApi';
import type { AICopywriterPostChild } from '$lib/types/AICopywriter/types';
import { Guid } from '@AlidaPackages/guid';

export const addIdToPostChildren = (postChildren: PostChild[]) => {
	return postChildren.map((child) => ({
		...child,
		id: new Guid(crypto.randomUUID()).toString(),
	})) satisfies AICopywriterPostChild[];
};
